import React from 'react'
import PropTypes from 'prop-types'
import { onClientSide } from '@/utils/utils'
import { Container, Wrapper, Info, Button } from './style'

import CertifiedPurchaseTag from '../Tag'

const CertifiedPurchaseHeader = ({
  shouldRender,
  trackingHandler,
  ...rest
}) => {
  function handleScroll() {
    trackingHandler()
    if (!onClientSide()) return
    const el = document.getElementById('VehicleCertifiedPurchase')
    if (!el) return
    const menuHeight = 64
    const margin = 20
    const y =
      el.getBoundingClientRect().top + window.scrollY - (menuHeight + margin)

    window.scrollTo({ top: y, behavior: 'smooth' })
  }

  return shouldRender ? (
    <Container {...rest}>
      <CertifiedPurchaseTag shouldRender size="big" />
      <Wrapper>
        <Button type="button" onClick={handleScroll}>
          Mais detalhes
        </Button>
      </Wrapper>
    </Container>
  ) : null
}

CertifiedPurchaseHeader.defaultProps = {
  shouldRender: false,
  trackingHandler: () => null,
}

CertifiedPurchaseHeader.propTypes = {
  shouldRender: PropTypes.bool,
  trackingHandler: PropTypes.func,
}

export default CertifiedPurchaseHeader
